/**
  * Add basic tab functionality with material design-like mobile focusing for nav buttons on mobile.
  */

const init = () => {
  const tabNav = document.querySelector('.tabbed-details__nav');
  const tabContents = document.querySelectorAll('.tabbed-details__tab-content');
  const useHashUrl = 'useHashUrl' in tabNav.dataset;

  tabNav.addEventListener('click', e => {
    if (e.target.tagName.toLowerCase() === 'button') {
      const tab = e.target;
      const tabs = tabNav.querySelectorAll('button');

      tabs.forEach(tb => {
        tabContents.forEach(t => t.hidden = true);
        tabs.forEach(tb => tb.classList.remove('active'));
        tab.classList.add('active');
        const centerOffset = Math.max(tab.offsetLeft + tab.offsetWidth / 2 - tab.offsetParent.offsetWidth / 2, 0);
        tabNav.scrollTo({
          left: centerOffset,
          behavior: 'smooth'
        });
      });

      const tabContent = document.getElementById(tab.dataset.target);

      if (tabContent) {
        tabContent.hidden = false;

        if (useHashUrl) {
          history.replaceState(null, null, `#${tab.dataset.target}`);
        }
      }
    }
  });

  if (useHashUrl) {
    // Activate tab if it's defined in URL hash
    const hash = new URL(window.location.href).hash?.split('#')[1];

    if (hash) {
      document.querySelector(`.tabbed-details__nav button[data-target="${hash}"]`)?.click();
    }
  }
}

export default { init };
